import React, { useEffect, useState } from "react";
import { useHistory, useParams, withRouter } from "react-router-dom";
import $ from 'jquery';
import "./OfflineMenu.css";
import moment from "moment-timezone";
import { post } from "../../app/shared/http";
import { browserName } from "react-device-detect";
import { Modal, ModalFooter } from "react-bootstrap";
import { handleException } from "../../app/util/util";
import { NavDropdownMenu, DropdownSubmenu } from "react-bootstrap-submenu";
import { getNewDeviceUuid, gnerateDeviceUniqueId } from "../../app/shared/deviceinfo.js";
import { addUserSettings, addUserBookDetails, addUserAllBooksDetails, addChaptersList, addChapterHighlights, addChapterProfLinks } from "../../app/models/db";
import { getChaptersList, getUserBookDetails, getBrowserStorageStatus, removeChaptersList, removeUserBookDetails } from "../../app/models/db";
function OfflineMenu(props) {
    const { bookVO, userVO, navTocType, chapterList, sectionVOList } = props;
    const { bookISBN, bookTitle, bookId, bookSize } = bookVO;
    const { userRole } = userVO;
    let history = useHistory();
    let { chapterid, userId } = useParams();
    const idbDetails = { bookISBN, userId };
    const chaptList = chapterList && chapterList;
    const chapNavTocType = navTocType && navTocType;
    const baseURL = localStorage.getItem("BASE_URL");
    const [currentPopup, setCurrentPopup] = useState('');
    const reactNode = localStorage.getItem("reactNodeName");
    const bookTotalSize = bookSize && (parseFloat((bookSize).split(" ")[0]));
    const chapSectList = sectionVOList && sectionVOList.filter((ele) => ele.entryNodeParentId === "-999");
    const [deviceUid, setDeviceUid] = useState();
    const [chapList, setChapList] = useState(chaptList && chaptList);
    const [offlineDownChapLink, setOfflineDownChapLink] = useState();
    const [noChaptSelcErrorMsg, setNoChaptSelcErrorMsg] = useState("");
    const [sectList, setSectList] = useState(chapSectList);
    const [linkGenerateLoadPerc, setLinkGenerateLoadPerc] = useState("0%");
    const [noSpaceErrPopupMsg, setNoSpaceErrPopupMsg] = useState("Not Enough Storage");
    useEffect(() => {
        if (chapSectList) {
            for (let sect of chapSectList) {
                let subChpaterIdList = [];
                if (sect.childSections) {
                    for (let subsect of sect.childSections) {
                        delete subsect.section_select_status;
                        delete subsect.default_section_select_status;
                        let subSectSubId = (subsect.entryNodeFileRef).split(".")[0];
                        subsect.entryNodeModifiedIdRef = subSectSubId;
                        subChpaterIdList.push(subSectSubId);
                    }
                }
                subChpaterIdList = subChpaterIdList.length > 1 ? Array.from(new Set(subChpaterIdList)) : subChpaterIdList;
                if (subChpaterIdList.length > 0) {
                    sect.childSectionsIdList = subChpaterIdList;
                    if (sect.entryNodeFileRef === '-999') {
                        sect.entryNodeModifiedIdRef = sect.childSectionsIdList[0]
                    } else if (!((sect.childSectionsIdList).includes(sect.entryNodeIdRef))) {
                        sect.entryNodeModifiedIdRef = sect.entryNodeIdRef;
                    }
                }
            }
        }
    }, [chapSectList === undefined]);
    useEffect(async () => {
        handleDefaultChaptersList();
        const deviceUniqueId = await gnerateDeviceUniqueId().then((deviceId) => { return deviceId; });
        setDeviceUid(deviceUniqueId);
    }, [chapNavTocType === 'none']);
    const handleDefaultChaptersList = async () => {
        let downlChaptList = await getChaptersList(idbDetails);
        if (downlChaptList.length > 0) {
            handleDefChapterSelect(downlChaptList);
        } else {
            handleChapterDefDeSelect();
        }
    }
    const handleHideModalPopup = () => {
        setCurrentPopup('')
        handleDefaultChaptersList();
        setNoChaptSelcErrorMsg("");
        setLinkGenerateLoadPerc("0%");
        setTimeout(() => {
            $('a#collasible-offline-dropdown.dropdown-toggle.nav-link').focus();
        }, 200)
    }
    const handleChapterDefDeSelect = () => {
        switch (chapNavTocType) {
            case "flat":
                const newSelChaptState = chaptList.map((chapt) => {
                    chapt.chapter_select_status = false;
                    return chapt;
                });
                setChapList(newSelChaptState);
                break;
            case "hierarchy":
                const newSelSectState = chapSectList.map((sect) => {
                    sect.section_select_status = false;
                    return sect;
                });
                setSectList(newSelSectState);
                break;
            default:
                break;
        }
    }
    const handleDefChapterSelect = async (downlChaptList) => {
        switch (chapNavTocType) {
            case "flat":
                chaptList && chaptList.map((chapt) => {
                    const filtDownlChapt = downlChaptList && downlChaptList.find(
                        (downlChapt) => downlChapt.chapterId === chapt.chapterId
                    );
                    chapt.chapter_select_status = (filtDownlChapt) ? true : false;
                    chapt.default_chapter_select_status = (filtDownlChapt) ? true : false;
                });
                break;
            case "hierarchy":
                chapSectList && chapSectList.map((sect) => {
                    const filtDownlSect = downlChaptList && downlChaptList.find((downlChapt) =>
                        (downlChapt.chapterId === (sect.entryNodeModifiedIdRef ? sect.entryNodeModifiedIdRef : sect.entryNodeIdRef))
                    );
                    sect.section_select_status = (filtDownlSect) ? true : false;
                    sect.default_section_select_status = (filtDownlSect) ? true : false;
                });
                break;
            default:
                break;
        }
    }
    const handleChapterSelect = (selChapterType, selChapterStatus, selChapterId) => {
        switch (chapNavTocType) {
            case "flat":
                const newSelChaptState = chaptList.map((chapt) => {
                    if (selChapterType === 'FlatChapterDeSel') {
                        if (chapt.chapterId === selChapterId) { chapt.chapter_select_status = selChapterStatus; }
                    } else { chapt.chapter_select_status = selChapterStatus; }
                    return chapt;
                });
                setChapList(newSelChaptState);
                break;
            case "hierarchy":
                const newSelSectState = chapSectList.map((sect) => {
                    if (selChapterType === 'HierChapterDeSel') {
                        if (sect.entryNodeIdRef === selChapterId) { sect.section_select_status = selChapterStatus; }
                    } else { sect.section_select_status = selChapterStatus; }
                    return sect;
                });
                setSectList(newSelSectState);
                break;
            default:
                break;
        }
    }
    const downloadChapter = async () => {
        let selectedChaptersList = [];
        let removedChaptersIdList = [];
        let selectedChaptersIdList = [];
        let selectedChaptersListforAnnots = [];
        switch (chapNavTocType) {
            case "flat":
                selectedChaptersListforAnnots = chaptList.filter((chapt) => { return (chapt.chapter_select_status) }).map((chaptEle) => ({ chapterId: chaptEle.chapterId }));
                const newSelChaptState = chaptList.map((chapt) => {
                    if (chapt.chapter_select_status && !chapt.default_chapter_select_status) {
                        chapt.default_chapter_select_status = true;
                        selectedChaptersIdList.push(({ chapterId: chapt.chapterId }))
                    } else if (!chapt.chapter_select_status && chapt.default_chapter_select_status) {
                        chapt.chapter_select_status = false;
                        chapt.default_chapter_select_status = false;
                        removedChaptersIdList.push(chapt.chapterId);
                    }
                    return chapt
                });
                setChapList(newSelChaptState);
                break;
            case "hierarchy":
                chapSectList.filter(
                    (sect) => { return (sect.section_select_status) }
                ).map((sectEle) => (
                    sectEle.entryNodeModifiedIdRef ? (
                        (sectEle.entryNodeFileRef !== '-999' && selectedChaptersListforAnnots.push({ chapterId: sectEle.entryNodeIdRef })),
                        (sectEle.childSections.map(sectEleSubsect => selectedChaptersListforAnnots.push({ chapterId: sectEleSubsect.entryNodeModifiedIdRef })))
                    ) : selectedChaptersListforAnnots.push({ chapterId: sectEle.entryNodeIdRef })
                ));
                const newSelSectState = chapSectList.map((sect) => {
                    if (sect.section_select_status && !sect.default_section_select_status) {
                        if (sect.entryNodeModifiedIdRef) {
                            if (sect.entryNodeFileRef !== '-999') { selectedChaptersIdList.push({ chapterId: sect.entryNodeIdRef }); }
                            sect.childSections.map(subsect => selectedChaptersIdList.push({ chapterId: subsect.entryNodeModifiedIdRef }))
                        } else selectedChaptersIdList.push({ chapterId: sect.entryNodeIdRef });
                        sect.default_section_select_status = true;
                        selectedChaptersList.push(sect);
                    } else if (!sect.section_select_status && sect.default_section_select_status) {
                        sect.section_select_status = false;
                        sect.default_section_select_status = false;
                        removedChaptersIdList.push((sect.entryNodeModifiedIdRef ? sect.entryNodeModifiedIdRef : sect.entryNodeIdRef));
                    }
                    return sect;
                });
                setSectList(newSelSectState)
                break;
            default:
                return false;
        }
        selectedChaptersList = selectedChaptersList.length > 1 ? Array.from(new Set(selectedChaptersList)) : selectedChaptersList;
        removedChaptersIdList = removedChaptersIdList.length > 1 ? Array.from(new Set(removedChaptersIdList)) : removedChaptersIdList;
        selectedChaptersIdList = selectedChaptersIdList.length > 1 ? Array.from(new Set(selectedChaptersIdList)) : selectedChaptersIdList;
        selectedChaptersListforAnnots = selectedChaptersListforAnnots.length > 1 ? Array.from(new Set(selectedChaptersListforAnnots)) : selectedChaptersListforAnnots;
        if (removedChaptersIdList.length > 0) {
            await removeChaptersList(removedChaptersIdList, idbDetails);
        }
        handleGetChapterAnnotsMetaData(selectedChaptersListforAnnots);
        handleGetChapterMetaData(selectedChaptersIdList, selectedChaptersList);
    }
    const handleGetChapterAnnotsMetaData = async (chapters) => {
        if (chapters && chapters.length > 0) {
            getChapterAnnotationAndBriefList(chapters);
            getChapterProfLink(chapters)
        }
    }
    const handleGetChapterMetaData = async (downloadChaptersIdList, downloadChaptersList) => {
        let downloadedChaptersList = await getChaptersList(idbDetails);
        if (downloadChaptersIdList && downloadChaptersIdList.length > 0) {
            setNoChaptSelcErrorMsg("");
            setCurrentPopup('downloadProgressPopup');
            getChapterData(downloadChaptersIdList, downloadChaptersList);
        } else if (downloadedChaptersList) {
            if (downloadedChaptersList.length > 0) {
                const downladedBookDetails = await getUserBookDetails(`CC_ISBN|${bookISBN}`, idbDetails);
                setCurrentPopup('copyChapterLinkPopup');
                setOfflineDownChapLink(await downladedBookDetails ? (downladedBookDetails.offlineURL) : "");
            } else {
                handleBookRemove();
            }
            setNoChaptSelcErrorMsg("");
        } else {
            setNoChaptSelcErrorMsg("Error: Please Select a Chapter to Download and Try Again !!");
        }
    }
    const handleChaptersSavedToIndexDB = async (chaptersMetaDataList, saveDataType) => {
        let browserSize = await getBrowserStorageStatus();
        let bookDetails, bookName = bookTitle;
        if ((bookTotalSize && bookTotalSize < browserSize) || browserSize == -1) {
            await addUserSettings(userVO, idbDetails);
            switch (saveDataType) {
                case 'chapterMetaData':
                    let chapterDataSavedInDb = await addChaptersList(chaptersMetaDataList, idbDetails, setLinkGenerateLoadPerc);
                    if (chapterDataSavedInDb) {
                        setLinkGenerateLoadPerc("100%");
                        setTimeout(() => {
                            const bookUrl = `${window.location.origin}/${reactNode}/read/users/${userId}/books/${bookISBN}/${chapterid}`;
                            setCurrentPopup('copyChapterLinkPopup');
                            setOfflineDownChapLink(bookUrl);
                        }, 2000);
                        const downladedBookDetails = await getUserBookDetails(`CC_ISBN|${bookISBN}`, idbDetails);
                        if (typeof downladedBookDetails == 'object' && Object.keys(downladedBookDetails).length > 1) {
                            bookDetails = downladedBookDetails;
                            bookDetails.generatedDate = moment().format();
                            if (!bookDetails.deviceId) bookDetails.deviceId = deviceUid;
                        } else {
                            bookDetails = {
                                "bookId": bookId,
                                "dateRemoved": null,
                                "bookISBN": bookISBN,
                                "deviceId": deviceUid,
                                "bookTitle": bookName,
                                "browser": browserName,
                                "uuid": getNewDeviceUuid(),
                                "generatedDate": moment().format(),
                                "offlineURL": `${window.location.origin}/${reactNode}/read/users/${userId}/books/${bookISBN}/${chapterid}`
                            }
                        }
                        updateChapterInfoToAdmin(bookDetails);
                    }
                    break;
                case 'chapterHighlights':
                    addChapterHighlights(chaptersMetaDataList, idbDetails);
                    break;
                case 'chapterProfLink':
                    addChapterProfLinks(chaptersMetaDataList, idbDetails);
                    break;
                default:
                    break;
            }
        } else if (saveDataType === 'chapterMetaData') {
            handleBrowserLimitExceed();
        }
    }
    const handleBookRemove = async () => {
        setCurrentPopup('');
        const removeBookDetails = await getUserBookDetails(`CC_ISBN|${bookISBN}`, idbDetails);
        await removeUserBookDetails("", idbDetails);
        if (!removeBookDetails) { return false; }
        updateChapterInfoToAdmin({
            "uuid": removeBookDetails.uuid,
            "dateRemoved": moment().format(),
            "bookId": removeBookDetails.bookId,
            "browser": removeBookDetails.browser,
        });
    }
    const handleBrowserLimitExceed = () => {
        setLinkGenerateLoadPerc("0%");
        setCurrentPopup('noStorageAvaiErrPopup')
        if (bookTotalSize) {
            setNoSpaceErrPopupMsg('Not Enough Storage')
            switch (chapNavTocType) {
                case "flat":
                    const newSelChaptState = chaptList.map((chapt) => {
                        chapt.default_chapter_select_status = false;
                        return chapt;
                    });
                    setChapList(newSelChaptState);
                    break;
                case "hierarchy":
                    const newSelSectState = chapSectList.map((sect) => {
                        sect.default_section_select_status = false;
                        return sect;
                    });
                    setSectList(newSelSectState)
                    break;
                default:
                    return false;
            }
        } else {
            setNoSpaceErrPopupMsg('Not Proper Storage')
        }
    }
    const handleCopyUrl = () => {
        navigator.clipboard.writeText(offlineDownChapLink);
    }
    const handleViewOfflineLinks = () => {
        history.push("/offline-links");
    }
    const handleOpenMenuOfflineLink = (openLinkVal) => {
        window.open(openLinkVal.target.value, '_blank')
    }
    const getChapterData = async (downlChaptsIdList, downlChaptsList) => {
        setLinkGenerateLoadPerc("10%");
        let reqData = {
            "bookVO": {
                "bookISBN": bookISBN,
                "chapterVOList": downlChaptsIdList
            }
        }
        post("/bookContentRetrievalService/getBookContentRVOffline", reqData, "ENV")
            .then(response => response.json())
            .then(data => {
                if (data.status === "false" && data.wkErrorCode) {
                    handleException(data);
                }
                if (data.bookVO && data.bookVO.bookChapterVOList) {
                    let bookChapterVo = data.bookVO.bookChapterVOList, savedBookData = [];
                    data.bookVO.bookChapterVOList = Array.isArray(bookChapterVo) ? bookChapterVo : [bookChapterVo];
                    bookChapterVo = data.bookVO.bookChapterVOList;
                    if (downlChaptsList && downlChaptsList.length > 0) {
                        downlChaptsList.map(downlChapt => {
                            let saveChapter, saveSubChpater;
                            if (downlChapt.entryNodeModifiedIdRef) {
                                saveSubChpater = bookChapterVo.filter(bookChpater => { return ((downlChapt.childSectionsIdList).includes(bookChpater.chapterId)) });
                                if (downlChapt.entryNodeFileRef !== '-999') {
                                    saveChapter = bookChapterVo.filter(bookChpater => { return (downlChapt.entryNodeIdRef === bookChpater.chapterId) });
                                    saveChapter[0].subChapters = saveSubChpater;
                                    savedBookData.push(saveChapter[0]);
                                } else {
                                    savedBookData.push({
                                        chapterId: downlChapt.entryNodeModifiedIdRef,
                                        chapterTitle: downlChapt.entryNodeTitle,
                                        navbarTitle: downlChapt.entryNodeTitle,
                                        subChapters: saveSubChpater
                                    });
                                }
                            } else {
                                saveChapter = bookChapterVo.filter(bookChpater => { return (downlChapt.entryNodeIdRef === bookChpater.chapterId) });
                                savedBookData.push(saveChapter[0]);
                            }
                        });
                        data.bookVO.bookChapterVOListModified = savedBookData;
                    } else {
                        data.bookVO.bookChapterVOListModified = bookChapterVo;
                    }
                    handleChaptersSavedToIndexDB(data.bookVO.bookChapterVOListModified, 'chapterMetaData');
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const getChapterAnnotationAndBriefList = async (downlChaptList) => {
        let reqData = {
            "bookVO": {
                "bookId": bookId,
            },
            "annotationVO": {
                "pageNum": 0,
                "bookId": bookId,
                "chapterVOList": downlChaptList,
                "ereaderNotesAndHighlightsPopoverFlowFlag": false
            },
            "briefVO": {
                "pageNum": 0,
                "bookId": bookId,
                "chapterVOList": downlChaptList,
                "ereaderNotesAndHighlightsPopoverFlowFlag": false
            }
        }
        post("/manageCases/getChapterBriefAndAnnotationOffline", reqData, "ENV")
            .then(response => response.json())
            .then(data => {
                if (data.status === "false" && data.wkErrorCode) {
                    handleException(data);
                }
                let highlight = []; let annotation;
                if (typeof data.annotationVOList != 'undefined') {
                    data.annotationVOList = Array.isArray(data.annotationVOList) ? data.annotationVOList : [data.annotationVOList];
                    highlight = [...highlight, ...data.annotationVOList];
                }
                if (typeof data.briefVOList != 'undefined') {
                    data.briefVOList = Array.isArray(data.briefVOList) ? data.briefVOList : [data.briefVOList];
                    highlight = [...highlight, ...data.briefVOList];
                }
                if (highlight.length) {
                    annotation = highlight.reduce(function (r, a) {
                        r[a.chapterId] = r[a.chapterId] || [];
                        r[a.chapterId].push(a);
                        return r;
                    }, Object.create(null));
                    handleChaptersSavedToIndexDB(annotation, 'chapterHighlights');
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const getChapterProfLink = async (chapterIds) => {
        let reqData = {
            "annotationVO": {
                "bookId": bookId,
                "chapterVOList": chapterIds
            },
        }
        let linkFetchURLUser;
        switch (userRole) {
            case "Professor":
                linkFetchURLUser = "/manageAnnotationService/getChapterLinkProfessorOffline";
                break;
            case "Student":
            default:
                linkFetchURLUser = "/manageAnnotationService/getChapterLinkStudentOffline";
                break;
        }
        post(linkFetchURLUser, reqData, "ENV")
            .then(response => response.json())
            .then(data => {
                if (data.status === "false" && data.wkErrorCode) {
                    handleException(data);
                }
                if (!data.annotationVOList) { return false; }
                const bookAnnotationList = data.annotationVOList;
                data.annotationVOList = Array.isArray(bookAnnotationList) ? bookAnnotationList : [bookAnnotationList];
                // // map chapter wise annotation.
                let annotation = data.annotationVOList.reduce(function (r, a) {
                    r[a.chapterId] = r[a.chapterId] || [];
                    r[a.chapterId].push(a);
                    return r;
                }, Object.create(null));
                handleChaptersSavedToIndexDB(annotation, 'chapterProfLink');
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const updateChapterInfoToAdmin = (bookVO) => {
        let reqData = { "bookVO": bookVO }
        post("/OfflineService/insertOfflineUrlDetail", reqData, "ENV")
            .then(response => response.json())
            .then(async (data) => {
                if (data.status === "false" && data.wkErrorCode) {
                    handleException(data);
                }
                await addUserBookDetails(data.bookVO, idbDetails);
                await addUserAllBooksDetails(data.bookVO, idbDetails);
            }).catch(error => {
                console.error("Something went wrong during update book details to admin!", error);
            });
    }
    const handledropdownSubMenu = (e, id) => {
        if (e.key === 'Enter') {
            id === "saveForOfflineUse" ? setCurrentPopup('chapterIndexPopup') : handleViewOfflineLinks();
        }
    }
    const handleSelectAll = (e) => {
        if (e.key === 'Enter') {
            handleChapterSelect('allChapterDeSel', true, "");
        }
    }
    const handleDeSelectAll = (e) => {
        if (e.key === 'Enter') {
            handleChapterSelect('allChapterDeSel', false, "");
        }
    }
    const handleChapterSelectOnEnter = (e, selChapterType, chapter_select_status, chapterId) => {
        if (e.key === 'Enter') {
            handleChapterSelect(selChapterType, chapter_select_status, chapterId);
        }
    }
    return (
        <React.Fragment>
            <NavDropdownMenu title="Offline" aria-label="Offline" id="collasible-offline-dropdown">
                <div className="navBarOfflineBlock" tabIndex="0">
                    <span data-testid="saveForOfflineUse" id="saveForOfflineUse" tabIndex="0" onKeyDown={(e) => handledropdownSubMenu(e, "saveForOfflineUse")}>
                        <DropdownSubmenu href="javascript:void(0)" aria-label="Save for Offline Use" title={<span onClick={() => setCurrentPopup('chapterIndexPopup')}>Save for Offline Use</span>} />
                    </span>
                    <span data-testid="viewAllOfflineLinks" id="viewAllOfflineLinks" tabIndex="0" onKeyDown={(e) => handledropdownSubMenu(e, "viewAllOfflineLinks")}>
                        <DropdownSubmenu href="javascript:void(0)" aria-label="View All Offline Links" title={<span onClick={() => handleViewOfflineLinks()}>View All Offline Links</span>} />
                    </span>
                </div>
            </NavDropdownMenu>
            <Modal size='lg' show={'chapterIndexPopup' === currentPopup} onHide={handleHideModalPopup} centered contentClassName='offline-popupContent p-4'>
                <Modal.Header>
                    <Modal.Title className='offline-popupTitle'>
                        Save this title for offline use
                    </Modal.Title>
                    <button className='close offline-popupClosebtn' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={handleHideModalPopup}>
                        <span aria-hidden="true" aria-label="Close Dialog">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body className="print-content-modals p-0">
                    <p className='offline-popupSubTitle mb-1 mt-3'>Select chapters to be available offline</p>
                    <p className='offline-popupTopTxt mb-1'>These chapters, as well as existing highlights and annotations, will be available to use without an internet connection. Other features may not be available offline.</p>
                    <p className='offline-popupSelect'>
                        <a><span data-testid="selectAll" onClick={() => handleChapterSelect('allChapterDeSel', true, "")} tabIndex="0" onKeyDown={(e) => handleSelectAll(e)}>Select All</span></a>
                        <span> | </span>
                        <a><span data-testid="deSelectAll" onClick={() => handleChapterSelect('allChapterDeSel', false, "")} tabIndex="0" onKeyDown={(e) => handleDeSelectAll(e)}>Deselect All</span></a>
                    </p>
                    <ul className='offline-popUpCol p-0 ml-3'>
                        {
                            chapNavTocType && chapNavTocType === "flat" ?
                                chaptList && chaptList.map((chapt, index) => {
                                    return (
                                        <li chapterid={chapt.chapterId} key={index}>
                                            <div className='row'>
                                                <div className='col-1 p-0 offline-popupCB'>
                                                    <input data-testid={`flat_${chapt.chapterId}`} type="checkbox" role="checkbox" aria-label={chapt.navbarTitle} className='offline-popupCheckBox mr-2' id={chapt.chapterId}
                                                        checked={chapt.chapter_select_status} onChange={() => handleChapterSelect('FlatChapterDeSel', !chapt.chapter_select_status, chapt.chapterId)} onKeyDown={(e) => handleChapterSelectOnEnter(e, 'FlatChapterDeSel', !chapt.chapter_select_status, chapt.chapterId)}>
                                                    </input>
                                                </div>
                                                <div className='col-11 pl-0 pr-3 offline-popupCheckBoxTxt'> {chapt.navbarTitle} </div>
                                            </div>
                                        </li>
                                    )
                                }) :
                                chapSectList && chapSectList.map((sect, index) => {
                                    return (
                                        <li chapterid={sect.entryNodeIdRef} key={index}>
                                            <div className='row pb-1'>
                                                <div className='col-1 p-0 offline-popupCB'>
                                                    <input data-testid={`hierarchy_${sect.entryNodeIdRef}`} type="checkbox" role="checkbox" aria-label={sect.entryNodeTitle} className='offline-popupCheckBox mr-2' id={sect.entryNodeIdRef}
                                                        checked={sect.section_select_status} onChange={() => handleChapterSelect('HierChapterDeSel', !sect.section_select_status, sect.entryNodeIdRef)} onKeyDown={(e) => handleChapterSelectOnEnter(e, 'HierChapterDeSel', !sect.section_select_status, sect.entryNodeIdRef)}>
                                                    </input>
                                                </div>
                                                <div className='col-11 pl-0 pr-3 offline-popupCheckBoxTxt'> {sect.entryNodeTitle} </div>
                                            </div>
                                        </li>
                                    )
                                })
                        }
                    </ul>
                </Modal.Body>
                <ModalFooter className='p-0 border-0'>
                    <div className='col-12 text-center'>
                        <button className='btn btn-primary m-auto offline-popupLinkBtn' onClick={downloadChapter}>Create Offline Link</button>
                    </div>
                    <div className='offline-popupErrorMsg col-12 text-center'>{noChaptSelcErrorMsg}</div>
                </ModalFooter>
            </Modal>
            <Modal size="sm" show={'downloadProgressPopup' === currentPopup} onHide={() => setCurrentPopup('downloadProgressPopup')} centered contentClassName="offline-linkProgrPopup">
                <div className="offline-generateLinkPopupLoad">
                    <div className="offline-generateLinkPopupLoadTxt">Generating Your Offline Link...</div>
                    <div className="progress offline-generateLinkPopupLoadProgress" role="progressbar">
                        <div className="progress-bar offline-generateLinkPopupLoadProgressBar" style={{ width: linkGenerateLoadPerc }}></div>
                    </div>
                </div>
            </Modal>
            <Modal size="md" show={'noStorageAvaiErrPopup' === currentPopup} onHide={() => setCurrentPopup('noStorageAvaiErrPopup')} centered contentClassName="offline-noStorageErrPopup">
                <Modal.Body className="print-content-modals">
                    <div data-testid="noStorageErrPopup" className="offline-noStorageErrPopupDiv">
                        {
                            noSpaceErrPopupMsg === 'Not Enough Storage' ?
                                <span className='offline-noStorageErrPopupTxt'>
                                    Error: There is not enough space in your browser cache to save these chapters for offline use. Please select fewer or different chapters,
                                    <a onClick={() => handleViewOfflineLinks()}> remove existing offline links</a>, or clear your browser cache.
                                </span> :
                                <span className='offline-noStorageErrPopupTxt'>
                                    Error: We are having trouble calculating the size of this book. Please
                                    <a href="https://support.aspenpublishing.com/hc/en-us/requests/new" target="_blank"> contact Customer Support</a> with this message.
                                </span>
                        }
                    </div>
                </Modal.Body>
                <ModalFooter className='p-0 border-0'>
                    <div className='col-12 text-center no-padding mb-3'>
                        <button className='btn btn-primary m-auto offline-noStorageErrPopupBtn'
                            onClick={() => setCurrentPopup('chapterIndexPopup')}>Okay</button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal size='lg' show={'copyChapterLinkPopup' === currentPopup} onHide={handleHideModalPopup} centered contentClassName='offline-popupContent p-3'>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" className='offline-popupTitle'>
                        Save this title for offline use
                    </Modal.Title>
                    <button data-testid="popupClosebtn" className='close offline-popupClosebtn' type="button" data-dismiss="modal" aria-label="Close Dialog" onClick={handleHideModalPopup}>
                        <span aria-hidden="true" aria-label="Close Dialog">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body className="print-content-modals p-0">
                    <p className='offline-popupBodyTxt mt-3 mb-2'>Offline Link for <span style={{ fontStyle: "italic" }}>{bookTitle}</span></p>
                    <div className="input-group pb-3">
                        <input data-testid="offline-popupLinkInput" type="text" defaultValue={offlineDownChapLink} onClick={(e) => handleOpenMenuOfflineLink(e)} className="form-control rounded-0 text-primary border border-dark offline-popupLinkInput" aria-label="Input group example" aria-describedby="btnGroupAddon" readOnly />
                        <button type='button' className='btn btn-primary rounded-0 offline-popupCopyBtn pt-1' onClick={() => handleCopyUrl()}>Copy</button>
                    </div>
                    <span className='offline-popupBottomTxt'><b>Instructions for using this link:</b></span>
                    <p className='offline-popupBottomTxt'>
                        Please save this link as a favorite in your current browser now. When you're offline, open the browser and click on the link from your favorites. You will be directed to your eBook content.
                    </p>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}
export default withRouter(OfflineMenu);